
const typeList = [
    {value: 'PAGAMENTO_GERENCIADO', label: 'Pagamento Gerenciado'},
    {value: 'CONSULTA_SCORE', label: 'Consulta Score'},
    {value: 'NEGATIVACAO', label: 'Negativacao'}
]

const statusList = [
    {value: 'EM_GERACAO', label: 'Em Geração'},
    {value: 'CRIADO', label: 'Criado'},
    {value: 'PAGO', label: 'Pago'},
    {value: 'EXPIRADO', label: 'Expirado'},
    {value: 'VENCIDO', label: 'Vencido'},
    {value: 'CANCELADO', label: 'Cancelado'}
]

export {statusList, typeList}